<template>
  <div class="bodyclass">
    <!--首页大框-->
    <div class="top-box-ins">
      <!--菜单-->
      <div class="top-menu">
        <div class="top-menu-t clearfloat">
          <div class="menu-logo fl"></div>
          <div class="menu-txt fl">
            <ul class="li-div-txt">
              <li><a class="dbi fb w100 menu-atxt" href="/">首页</a></li>
              <li> <a class="dbi fb w100 menu-atxt" href="/chanping1">产品</a>
                <div class="li-div" style="width:1000px;">
                  <div class="li-div-left fl"> <span class="tl dbi">产品</span> </div>
                  <div class="w68 fl">
                    <ul class="li-div-txt">
                      <li class="" style="width:23%"> 
                        <a class="dbi  w100 menu-atxt" href="/chanping4">
                          <div class="li-div-d2 mt10 "> 
                            <img src="../assets/images/z13-ytj.png" class="li-div-img">
                          </div>
                          <h1 class="f16 lh20 mt10 dbi">视觉智能体</h1>
                        </a> 
                      </li>
                      <li style="width:23%"> 
                        <a class="dbi w100 menu-atxt" href="/chanping3">
                          <div class="li-div-d2 mt10"> 
                            <img src="../assets/images/z12-ytj.png" class="li-div-img">
                          </div>
                          <h1 class="f16 lh20 mt10 dbi">新一代公共安全视觉智能体</h1>
                        </a> 
                      </li>
                      <li class="" style="width:23%"> <a class="dbi  w100 menu-atxt" href="/chanping1">
                          <div class="li-div-d2 mt10 "> <img src="../assets/images/z1-ytj.png" class="li-div-img"></div>
                          <h1 class="f16 lh20 mt10 dbi">谛视万象多模态视觉大模型</h1>
                        </a> </li>
                      <li style="width:23%"> <a class="dbi  w100 menu-atxt" href="/chanping2">
                          <div class="li-div-d2 mt10 "> <img src="../assets/images/z2-ytj.png" class="li-div-img"></div>
                          <h1 class="f16 lh40">视觉大模型一体机</h1>
                        </a> </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li><a class="dbi fb w100 menu-atxt" href="/jiejfa1">解决方案</a>
                <div class="li-div" style="width:1300px;">
                  <div class="li-div-left fl" style="width:220px"> <span class="tl dbi">解决方案</span> </div>
                  <div class="w70 fl" style="height:148px;">
                    <ul class="">
                      <li> <a class="dbi  w100 menu-atxt" href="/jiejfa1">
                          <div class="li-div-d2 mt10 "> <img src="../assets/images/z3-ytj.png" class="li-div-img"></div>
                          <h1 class="f16 lh40 ">公共安全行业解决方案</h1>
                        </a> </li>
                      <li> <a class="dbi  w100 menu-atxt" href="/yijii2">
                          <div class="li-div-d2 mt10 "> <img src="../assets/images/z4-ytj.png" class="li-div-img"></div>
                          <h1 class="f16 lh40">应急行业解决方案</h1>
                        </a> </li>
                      <li> <a class="dbi  w100 menu-atxt" href="/chengguan3">
                          <div class="li-div-d2 mt10 "> <img src="../assets/images/z5-ytj.png" class="li-div-img"></div>
                          <h1 class="f16 lh40">城管行业解决方案</h1>
                        </a> </li>
                      <li> <a class="dbi  w100 menu-atxt" href="/jiaotong4">
                          <div class="li-div-d2 mt10 "> <img src="../assets/images/z6-ytj.png" class="li-div-img"></div>
                          <h1 class="f16 lh40">交通行业解决方案</h1>
                        </a> </li>
                      <li> <a class="dbi  w100 menu-atxt" href="/qiyeigl5">
                          <div class="li-div-d2 mt10 "> <img src="../assets/images/z7-ytj.png" class="li-div-img"></div>
                          <h1 class="f16 lh40">企业管理解决方案</h1>
                        </a> </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li><a class="dbi fb w100 menu-atxt" href="/severHtml">服务&生态</a></li>
              <li><a class="dbi fb w100 menu-atxt" href="/gywmHtml">关于我们</a></li>
            </ul>
          </div>
        </div>
      </div>
      <!--菜单end-->

      <!--背景图-->
      <div class="top-backgr">
        <div class="top-box-ins-img bgimg"></div>
        <div class="top-box-ins-imga1 bgimg2"></div>
      </div>
      <!-- <div class="top-backgr">
    <div class="top-box-ins-img" style="background:url(../assets/images/bana-11.jpg) center center no-repeat;background-size:cover;" ></div>
    <div class="top-box-ins-imga1" style="background:url(../assets/images/z11-ytj.png) center center no-repeat;background-size:cover;" ></div>
  </div> -->
      <!--背景图end-->

      <!--首页大框end-->
    </div>
    <!--首页大框-->
    <!--内容大框-->
    <div class="main pt84 " style="min-height:500px;">

      <!--解决方案-->
      <div class="w100 lh40 tc WOW animate__animated animate__fadeInUp"> <span class="db f48 fb lp2 mt40">关于我们</span> <span
          class="db f24  lp2 mt10 col-gr">about Us</span> </div>
      <div class="w90 jz mt40 lh30 f16">
       
        <p class="tl mb40 WOW animate__animated animate__fadeInUp">
          上海谛视万象科技有限公司是上海市重点扶植的人工智能高科技企业，专注智慧视觉全场景服务。公司核心产品谛视多模态视觉大模型平台，融合前沿技术，实现多源数据高效处理与精准感知预警。凭借领先的视觉多模态技术和全生态融合，赋能党政、交通、公共安全、能源、水利、家庭等众多领域客户，助力构建智能公共安全屏障，加速业务流程智效革新，驱动行业智能化深度转型，实现安全保障能力跃升与运营效率质的飞跃。未来，公司将持续深耕技术，拓展应用场景，致力于成为全球领先的视觉智能科技企业。
        </p>

        <p class="f16 fb  tl WOW animate__animated animate__fadeInUp" style="color:rgb(255,0,0);">公司地址：上海市徐汇区龙爱路27号芒果广场A座1906室</p>
        <p class="f16 fb  tl WOW animate__animated animate__fadeInUp" style="color:rgb(255,0,0);">联系电话：4007628008</p>
        
      </div>
      <!--解决方案end-->

    </div>
    <!--内容大框end-->
    <!--底宣-->
    <div class="btto-a1 mt100 ov">
      <div class="btto-a2 jz mt30">
        <ul class="w100 he68">
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.1s;">
            <div class="btt-ico fl ">
              <img src="../assets/images/za1-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">全场景算法</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">algorithm</span>
              </div>
              <div class="mt4 col-gr3">多种行业全场景算法</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.3s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za2-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">算法灵活自定义</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">Custom</span>
              </div>
              <div class="mt4 col-gr3">可通过文字自定义描述方式新增修改</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.5s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za3-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">国产化生态支持</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">support</span>
              </div>
              <div class="mt4 col-gr3">基于自主可控的国产化IT底层架构</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.7s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za4-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">完善标准化</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">standardization</span>
              </div>
              <div class="mt4 col-gr3">支持主流音视频标准化协议</div>
            </div>
          </li>
          <li class="fl WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.9s;">
            <div class="btt-ico fl">
              <img src="../assets/images/za5-ytj.png" width="68" height="68" alt="" />
            </div>
            <div class="fl ml10">
              <div class="mt10">
                <span class="dbi col-gr2 f18 fb lp1">大模型技术</span>
                <span class="dbi col-gr3 f14  lp1 abcd mt4 ml6">Large Model</span>
              </div>
              <div class="mt4 col-gr3">使用Transformer架构</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--底宣end-->
     <!--底宣2-->
    <div class="btto-b-a1 ov">
      <div class="mt30 w100 jz dbi">
        <div class="tc WOW animate__animated animate__fadeInRight animate__duration-5s" style="animation-delay: 0.1s;"> <img src="../assets/images/ying-28.jpg" width="76" height="76" alt="" class="  dbi " /></div>
        <ul class="w100 he92 tc mt20">
          <li class=" WOW animate__animated animate__fadeInRight animate__duration-5s dbi" style="animation-delay: 0.1s;">
            <div class="tl f24 white he35 fl">上海谛视万象科技有限公司</div>
            <div class="ov  fl ml30">
              <span class="dbi btto-b-sp fl">
                <img src="../assets/images/ico2_3.png" width="38" height="38" alt="" />
              </span>
              <span class="dbi fl ml10 mt10 f14 col-gr3">联系电话：4007628008</span>
            </div>
          <!--  <div class="ov fl ml30">
              <span class="dbi btto-b-sp fl">
                <img src="../assets/images/ico2_1.png" width="38" height="38" alt="" />
              </span>
              <span class="dbi fl ml10 mt10 f14 col-gr3">地址：上海市普陀区真北路2653号天地科技园</span>
            </div>-->
          </li>
                   
        </ul>
      </div>
    </div>
    <!--底宣2end--> 
    <!--底宣3-->
    <div class="he90 tc btto-c"> <span class="dbi col-gr3  mt30 mr40">辽ICP备2025061615号</span> <span class="dbi col-gr3  mt30">Copyright © 2004 - 2025 谛视万象版权所有</span> </div>
    <!--底宣3end-->
  </div>
</template>
<script setup>
// , onUpdated, onUnmounted, ref
import { onMounted } from 'vue';
import * as WOW from 'wowjs';
// let wowInstance = null;
onMounted(() => {
  new WOW.WOW({
    // boxClass: 'wow',
    animateClass: 'animate__animated',
    offset: 50,       // 元素进入视口 100px 后触发
    // mobile: true,      // 移动端启用
    live: true,        // 监听动态添加的元素
  }).init();
})
</script>
<style scoped>
@import '@/assets/css/default.css';
@import '@/assets/css/font-awesome.min.css';
@import '@/assets/css/margin.css';
@import '@/assets/css/main.css';

/* style="background:url(../assets/images/bana-9.jpg) center center no-repeat;background-size:cover;" */
/* style="background:url(../assets/images/z8-ytj.png) center center no-repeat;background-size:cover;" */
.bgimg {
  background: url(../assets/images/bana-11.jpg) center center no-repeat;
  background-size: cover;
}

.bgimg2 {
  background: url(../assets/images/z11-ytj.png) center center no-repeat;
  background-size: cover;
}

.animate__animated {
  animation-duration: 2s !important;
}
</style>